"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNamesWithCountCellFormatter = exports.NamesWithCountCell = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
var nameCountCellClass = (0, data_catalog_shared_1.cssClass)('nameCountCell', data_catalog_shared_1.elideTextStyle, data_catalog_shared_1.cellPaddingStyle);
var disabledNameCountCellClass = (0, data_catalog_shared_1.cssClass)('nameCountCell', data_catalog_shared_1.elideTextStyle, data_catalog_shared_1.cellPaddingStyle, {
    pointerEvents: 'none',
    opacity: 0.6
});
var plusMoreCountsClass = (0, data_catalog_shared_1.cssClass)('plusMoreCounts', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Small,
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
    color: widgets_1.TabStyles.Typography.Color.Disabled
});
function NamesWithCountCell(props) {
    var names = props.names.slice(0, props.maxShown).join(', ');
    var plusMore = (0, data_catalog_shared_1.messageWithOrWithoutCount)(props.count - props.maxShown, { withCount: Localize_1.Messages.PlusMore, withoutCount: function () { return ''; } });
    return (react_1.default.createElement("div", { className: props.disabled ? disabledNameCountCellClass : nameCountCellClass, title: names + ' ' + plusMore },
        names,
        props.count > props.maxShown ?
            react_1.default.createElement("span", { className: plusMoreCountsClass }, plusMore)
            : null));
}
exports.NamesWithCountCell = NamesWithCountCell;
function createNamesWithCountCellFormatter(getNamesFromRowData, getCountFromRowData, maxShown, getDisabledFromRowData) {
    if (maxShown === void 0) { maxShown = 3; }
    return function (props) { return (react_1.default.createElement(NamesWithCountCell, { names: getNamesFromRowData(props.row.data), count: getCountFromRowData(props.row.data), disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, maxShown: maxShown })); };
}
exports.createNamesWithCountCellFormatter = createNamesWithCountCellFormatter;
//# sourceMappingURL=NamesWithCountCell.js.map